import { useEffect, useRef } from 'react';
import { message } from 'antd';
import { BrowserQRCodeSvgWriter } from '@zxing/browser';

/** QRコードのサイズ */
const QR_CODE_SIZE = 250;

/** QRCodeCustomのプロパティ型 */
interface QRCodeCustomProps {
    /** QRコードにエンコードするデータ */
    data: string;
}

/**
 * QRコードを表示するコンポーネント
 */
export const QRCodeCustom = ({ data }: QRCodeCustomProps) => {
    const qrCodeRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!qrCodeRef.current || !data) return;

        qrCodeRef.current.innerHTML = '';

        try {
            const codeWriter = new BrowserQRCodeSvgWriter();
            const svgElement = codeWriter.write(
                data,
                QR_CODE_SIZE,
                QR_CODE_SIZE,
            );
            qrCodeRef.current.appendChild(svgElement);
        } catch {
            message.error('QRコードの生成に失敗しました');
        }

        return () => {
            if (qrCodeRef.current) {
                qrCodeRef.current.innerHTML = '';
            }
        };
    }, [data]);

    return (
        <div
            ref={qrCodeRef}
            className='flex justify-center items-center'
        />
    );
};
